export const ID_CARD = "ID_CARD";
export const PASSPORT = "PASSPORT";
export const DRIVERS_LICENCE = "DRIVERS_LICENCE";
export const OTHER_DOCUMENT = "OTHER_DOCUMENT";
